import { Component, ElementRef, OnInit } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { EditorService } from '../services/editor.service';
import { HeaderInputComponent } from './header-input/header-input.component';
import { HeaderEditorStoreService } from './header-editor-store.service';
import { HeaderConfig } from '@urbannex/storethemes';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';


@Component({
  selector: 'ngx-header-editor',
  templateUrl: './header-editor.component.html',
  styleUrls: ['./header-editor.component.scss']
})

export class HeaderEditorComponent implements OnInit {
  menuGroups:any;
  title = "Editing Header";
  menuTag = "editHeaderMenu";
  inputComponent = new DynamicInputComponent(HeaderInputComponent);
  topLevelMenu:MenuGroup;
  secondaryMenus:MenuGroup[] = [];
  tertiaryMenus:MenuGroup[] = [];

  menuGroup:MenuGroup = {
    title:"Editing Header",
    menuTag:"editHeaderMenu",
    menuItems: [
      {
        title:'Header Layout',
      },
      {
        title:'Sections',
        children:[
          {
            title:'Top Header',
            /* children:[
              {
                title:"Left"
              },
              {
                title:"Center"
              },
              {
                title:"Right"
              }
            ] */
          },
          {
            title:'Main Header',
            /* children:[
              {
                title:"Logo Navigation"
              },
              {
                title:"Main Navigation"
              },
              {
                title:"Toolbar"
              }
            ] */
          },
          {
            title:"Bottom Header",
            /* children:[
              {
                title:"Main Navigation"
              }
            ] */
          }
      ]
      },
      {
        title:'Styling'
      },
      {
        title:'Top Header'
      },
      {
        title:'Main Header'
      },
      {
        title:'Bottom Header'
      }
    ] 
  }
  menuItems:NbMenuItem[] = []
    /* {
      title:'Header Settings',
    },
    {
      title:'Sections'
    },
    {
      title:'Styling'
    }
  ] */

  previousMenu:NbMenuItem[] = [];

  constructor(
    private el:ElementRef,
    private headerEditorStore:HeaderEditorStoreService,
    private previewEditStore:PreviewEditStoreService,
    private editorService:EditorService,
    private menuService:NbMenuService) { }

  ngOnInit(): void {
    //this.createMenusFromGroup(this.menuGroup)
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        this.setMenu(selectedItem);
        console.log({selectedItem:selectedItem});
      }
    })
    this.previewEditStore.siteHeader$.subscribe((headerConfig:HeaderConfig) => {
      this.headerEditorStore.init(headerConfig);
    })
  }

  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    /* let host = <HTMLElement>this.el.nativeElement;
    let menuItemCollections = host.getElementsByTagName("LI");
    for(let i=0;i<menuItemCollections.length;i++){
      menuItemCollections[i].classList.add('narrow-item');
      menuItemCollections[i].children[0].classList.add('narrow-item');
      let achorElement = <HTMLElement>menuItemCollections[i].children[0];
      achorElement.style.setProperty('display','unset');
    } */
  }

  /* createMenusFromGroup(menuGroup:MenuGroup){
    this.topLevelMenu = {
      title:menuGroup.title,
      menuTag:menuGroup.menuTag,
      menuItems:this.getSecondaryMenuItems(menuGroup.menuItems)
    }
    console.log(this.topLevelMenu)
    console.log(this.secondaryMenus)
    console.log(this.tertiaryMenus);
  }

  createSecondaryMenu(menuItem:NbMenuItem){
    let menuItems:NbMenuItem[]=[];
    menuItem.children.forEach(childMenuItem =>{
      if(childMenuItem.children == undefined && childMenuItem.children == null){
        menuItems.push(childMenuItem);
      }else{
        this.createTertiaryMenu(childMenuItem);
        const { children, ...rest } = childMenuItem;
        menuItems.push(rest);
      }
    })
    let secondaryMenu:MenuGroup = {
      title:menuItem.title,
      menuItems:menuItems,
      menuTag:this.toCamelCase(menuItem.title)
    }
    this.secondaryMenus.push(secondaryMenu);
  }

  createTertiaryMenu(menuItem:NbMenuItem){
    let _menuItems:NbMenuItem[]=[];
    menuItem.children.forEach(childMenuItem =>{
      _menuItems.push(childMenuItem);
    })
    let tertiaryMenu:MenuGroup = {
      title:menuItem.title,
      menuItems:_menuItems,
      menuTag:this.toCamelCase(menuItem.title)
    }
    this.tertiaryMenus.push(tertiaryMenu);
  }

  toCamelCase(sentenceCase) {
    var out = "";
    sentenceCase.split(" ").forEach(function (el, idx) {
        var add = el.toLowerCase();
        out += (idx === 0 ? add : add[0].toUpperCase() + add.slice(1));
    });
    return out;
  }

  getSecondaryMenuItems(menuItems:NbMenuItem[]){
    let _menuItems:NbMenuItem[] = [];
    menuItems.forEach(menuItem => {
      if(menuItem.children == undefined || menuItem.children == null){
        _menuItems.push(menuItem);
      }else{
        this.createSecondaryMenu(menuItem);
        const { children, ...rest } = menuItem;
        _menuItems.push(rest);
      }
    })
    return _menuItems;
  } */

}
